import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Cancel from '@material-ui/icons/Cancel';
import DragHandle from '@material-ui/icons/DragHandle';

const ManageFiltersModal = ({ open, onClose, filters, onSave }) => {
  const [localFilters, setLocalFilters] = useState([]);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(() => {
    if (open) {
      setLocalFilters(filters.map(f => ({ ...f })));
    }
  }, [open]);

  const handleDragStart = (index) => {
    dragItem.current = index;
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    dragOverItem.current = index;
  };

  const handleDrop = () => {
    if (dragItem.current === null || dragOverItem.current === null) return;
    if (dragItem.current === dragOverItem.current) return;

    const updated = [...localFilters];
    const [dragged] = updated.splice(dragItem.current, 1);
    updated.splice(dragOverItem.current, 0, dragged);
    setLocalFilters(updated);

    dragItem.current = null;
    dragOverItem.current = null;
  };

  const toggleActive = id => {
    setLocalFilters(prev =>
      prev.map(f => (f.id === id ? { ...f, isActive: !f.isActive } : f)),
    );
  };

  const handleSave = () => {
    onSave(localFilters);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Manage Filters</DialogTitle>
      <DialogContent dividers style={{ padding: 0 }}>
        <div style={{ display: 'flex', borderBottom: '1px solid #ddd', padding: '8px 16px', fontWeight: 'bold', fontSize: 14 }}>
          <div style={{ width: 40 }}></div>
          <div style={{ flex: 1 }}>Name</div>
          <div style={{ flex: 2 }}>Description</div>
          <div style={{ width: 60, textAlign: 'center' }}>Active</div>
        </div>
        {localFilters.map((filter, index) => (
          <div
            key={filter.id}
            draggable
            onDragStart={() => handleDragStart(index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDrop={handleDrop}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '4px 16px',
              borderBottom: '1px solid #eee',
              opacity: filter.isActive ? 1 : 0.6,
              cursor: 'grab',
            }}
          >
            <div style={{ width: 40, display: 'flex', alignItems: 'center' }}>
              <DragHandle style={{ color: '#999' }} />
            </div>
            <div style={{ flex: 1, fontSize: 14 }}>{filter.filterName}</div>
            <div style={{ flex: 2, fontSize: 13, color: '#666' }}>{filter.filterDescription || ''}</div>
            <div style={{ width: 60, textAlign: 'center' }}>
              <IconButton size="small" onClick={() => toggleActive(filter.id)}>
                {filter.isActive ? (
                  <CheckCircle style={{ color: '#4caf50' }} />
                ) : (
                  <Cancel style={{ color: '#d32f2f' }} />
                )}
              </IconButton>
            </div>
          </div>
        ))}
        {localFilters.length === 0 && (
          <div style={{ padding: 24, textAlign: 'center', color: '#999' }}>No filters saved yet.</div>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '12px 24px' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          style={{ backgroundColor: '#315382', color: '#fff' }}
        >
          Save Order
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageFiltersModal;
